module.exports = __webpack_public_path__ + "static/media/count-10.3298bacd.mp3";